import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { EquipmentGet, ListItem, RepositoryModal } from '../../shared'
import { EquipmentGetListComponent } from './equipment-get-list.component'

@Component({
    templateUrl: './equipment-get-modal.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent, WjInputModule],
})
export class EquipmentGetModalComponent extends RepositoryModal<EquipmentGet> {
    equipmentOptions: ListItem<string>[] = []

    protected onInitialized() {
        this.equipmentOptions = (this.editOptions.initializeParams as EquipmentGetListComponent).equipmentOptions
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        super.onSave(
            result => {
                ;(this.editOptions.initializeParams as EquipmentGetListComponent).parent.refresh()
                resolveSave(result)
            },
            rejectSave,
        )
    }
}
